import React from 'react';
type DottedRingProps = {
  dots?: number;
  className?: string;
  children?: React.ReactNode;
};

/** The dotted circle from Bas' business card, optionally framing content. */
export function DottedRing({
  dots = 44,
  className = '',
  children
}: DottedRingProps) {
  const r = 46;
  return <div className={`relative flex aspect-square items-center justify-center ${className}`} data-id="element-250" data-mp="1jyc4en4fp0gm">
      <svg aria-hidden viewBox="0 0 100 100" className="absolute inset-0 h-full w-full" data-id="element-251" data-mp="n8lb2r7vpjce">
        {Array.from({
        length: dots
      }).map((_, i) => {
        const a = i / dots * Math.PI * 2;
        return <circle key={i} cx={50 + r * Math.cos(a)} cy={50 + r * Math.sin(a)} r={1.1} fill="currentColor" data-id="element-252" data-mp="w99q9p90dpqv" data-mpi={i} />;
      })}
      </svg>
      {children && <div className="relative text-center" data-id="element-253" data-mp="110jf4nmqgp1p">{children}</div>}
    </div>;
}